module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_360.c81012bd.webp";